
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/homepage",
      function () {
        return require("private-next-pages/team/homepage.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/homepage"])
      });
    }
  